















import Vue from 'vue'
import CustomCheckbox from '@/components/Common/CustomCheckbox.vue'
import vClickOutside from 'v-click-outside'

interface Props {
  checked: boolean
  partialCheck: boolean
  allCheckedOnPage: boolean
  showAllChecking: boolean
}

interface Methods {
  showAllChecked: (status: boolean) => void
}

interface Computed {
  model: boolean
}

export default Vue.extend<{}, Methods, Computed, Props>({
  components: {
    CustomCheckbox,
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  props: {
    checked: {
      required: true,
    },
    partialCheck: {
      required: true,
    },
    allCheckedOnPage: {
      required: true,
    },
    showAllChecking: {
      required: true,
    },
  },
  methods: {
    showAllChecked(status: boolean) {
      this.$emit('show-all-check', status)
    },
  },

  computed: {
    model: {
      get() {
        return this.allCheckedOnPage
      },
      set(value) {
        if (this.partialCheck) {
          return this.$emit('input', true)
        }
        this.$emit('input', value)
      },
    },
  },
})
